// Lightweight history-based router helpers shared across the app.

export function parsePath(pathname) {
  const clean = (pathname || '/').replace(/\/+$/, '') || '/';
  if (clean === '/' || clean === '') return { name: 'home', path: '/' };
  if (clean === '/about') return { name: 'about', path: '/about' };
  if (clean === '/contact') return { name: 'contact', path: '/contact' };
  const m = clean.match(/^\/case\/([^/?#]+)$/);
  if (m) return { name: 'case', slug: m[1], path: clean };
  return { name: 'home', path: '/' };
}

export function navigate(path) {
  if (typeof path !== 'string') return;
  // In-page hash anchors should not push history routes.
  if (path.startsWith('#')) {
    const id = path.slice(1);
    const el = id ? document.getElementById(id) : null;
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    return;
  }
  if (path === window.location.pathname + window.location.search) return;
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

// onClick handler for SPA <a> tags. Lets users cmd-click / middle-click open in
// a new tab as expected; otherwise intercepts and routes via pushState.
export function onNavClick(e) {
  if (e.defaultPrevented) return;
  if (e.button !== 0) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  const a = e.currentTarget;
  const href = a.getAttribute('href');
  if (!href) return;
  // Hash anchors stay native.
  if (href.startsWith('#')) return;
  // External / non-internal links pass through.
  if (/^[a-z]+:/i.test(href)) return;
  if (a.target && a.target !== '' && a.target !== '_self') return;
  e.preventDefault();
  navigate(href);
}
